<template>
  <div class="result-page">
    <Card class="result-card">
      <template #content>
        <div class="result-content">
          <i class="pi pi-check-circle success-icon" />
          <h1>¡Pago exitoso!</h1>
          <p>Tu suscripción ha sido activada correctamente.</p>
          <Button label="Ir al Dashboard" icon="pi pi-home" @click="router.push('/')" />
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import Card from 'primevue/card';
import Button from 'primevue/button';
const router = useRouter();
</script>

<style scoped>
.result-page { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #f8fafc; }
.result-card { max-width: 400px; width: 100%; }
.result-content { text-align: center; padding: 1rem; }
.success-icon { font-size: 4rem; color: #10b981; margin-bottom: 1rem; }
h1 { color: #1e293b; margin-bottom: 0.5rem; }
p { color: #6b7280; margin-bottom: 1.5rem; }
</style>
